import { useParams } from 'react-router';
import { useUnitWorkloadData } from '@/hooks';
import { UnitWorkloadNavigation } from '../Common/UnitWorkloadNavigation';
import { UnitWorkloadHeader } from '../Common/UnitWorkloadHeader';
import { TdTrdPanel } from '../Common/TdTrdPanel';
import { Loader } from '@/components/Common/Loader';
import { UnitTeachingRelatedDuties } from './UnitTeachingRelatedDuties';

export const UnitTeachingRelatedDutiesView = () => {
  const { unitWorkloadId } = useParams();
  const uwId = unitWorkloadId ? parseInt(unitWorkloadId, 10) : null;
  if (uwId === null || isNaN(uwId)) {
    throw new Error('unitWorkloadId is required and must be a valid number');
  }
  const { unitWorkloadDetails, unitWorkloadCampuses, isPageLoading } = useUnitWorkloadData(uwId);

  if (isPageLoading) {
    return <Loader />;
  }

  return (
    unitWorkloadDetails &&
    unitWorkloadCampuses && (
      <>
        <div className="flex h-full w-screen flex-col items-start overflow-auto">
          <UnitWorkloadHeader unitWorkloadDetails={unitWorkloadDetails} />
          <UnitWorkloadNavigation unitWorkloadDetails={unitWorkloadDetails} />
          <div className="flex h-full w-screen flex-row items-stretch justify-start gap-14 overflow-auto bg-white">
            <TdTrdPanel
              unitWorkloadId={uwId}
              unitWorkloadDetails={unitWorkloadDetails}
              unitWorkloadCampuses={unitWorkloadCampuses}
            />
            <UnitTeachingRelatedDuties unitWorkloadId={uwId} />
          </div>
        </div>
      </>
    )
  );
};
